<template>
  <q-page padding>
      <div>
        <q-table
          title="Note Templates"
          :data="noteTemplates"
          :columns="columns"
          :pagination.sync="pagination"
          row-key="id">
          <div slot="top" slot-scope="props" class="row flex-center fit">
            <div class="on-left">Note Templates</div>
            <q-btn class="float-right" @click="addNewNoteTemplate">Add New</q-btn>
          </div>
          <q-td slot="body-cell-enabled" slot-scope="props" :props="props" >
            <!--{{ JSON.stringify(props, null, 2) }}-->
            <!--{{ JSON.stringify(props.value, null, 2) }}-->
            <q-checkbox v-model="props.row.enabled" @input="updateNoteTemplateEnabled(props)"/>
          </q-td>
          <q-td slot="body-cell-actions" slot-scope="props" :props="props" >
            <q-btn
              dense
              flat
              icon="edit"
              @click="editNoteTemplate(props.row.id)"
            />
            <q-btn
              dense
              flat
              icon="content_copy"
              @click="copyNoteTemplate(props.row)"
            />
            <q-btn
              dense
              flat
              icon="delete"
              @click="deleteNoteTemplate(props.row)"
            />
            <q-btn
              dense
              flat
              icon="file_download"
              @click="downloadNoteTemplate(props.row)"
            />
          </q-td>
        </q-table>
      </div>
  </q-page>
</template>

<script>
export default {
  // name: 'PageName',
  data () {
    return {
      pagination: {
        sortBy: null, // String, column "name" property value
        descending: false,
        page: 1,
        rowsPerPage: 10 // current rows per page being displayed
      },
      columns: [
        {
          name: 'enabled',
          required: true,
          label: 'Enabled',
          align: 'center',
          field: 'enabled',
          sortable: true,
          sort: (a, b) => (a < b) * 2 - 1
        },
        {
          name: 'name',
          required: true,
          label: 'Name',
          align: 'left',
          field: 'name',
          sortable: true
        },
        {
          name: 'actions',
          required: true,
          label: 'Actions',
          align: 'center',
          field: null,
          sortable: false
        }
      ]
    }
  },
  computed: {
    noteTemplates () { return this.$store.getters.getNoteTemplatesAsAry }
  },
  methods: {
    editNoteTemplate (id) {
      this.$router.push('/noteTemplates/' + id + '/edit')
    },
    updateNoteTemplateEnabled (v) {
      this.$store.dispatch('updateNoteTemplate', v.row)
    },
    copyNoteTemplate (row) {
      let clone = Object.assign({}, row)
      clone.name += ' copy'
      this.$store.dispatch('addNoteTemplate', clone)
    },
    deleteNoteTemplate (row) {
      this.$q.dialog({
        title: 'Delete Note Template ?',
        message: 'Are you sure you want to delete the note template named \'' + row.name + '\'?',
        ok: true,
        cancel: true,
        position: 'top'
      }).then(() => {
        return this.$store.dispatch('deleteNoteTemplateWithId', row.id)
      })
    },
    downloadNoteTemplate (row) {
    },
    addNewNoteTemplate () {
      this.$store.dispatch('addNoteTemplate', null).then((newNoteTemplateId) => {
        this.editNoteTemplate(newNoteTemplateId)
      })
    }
  }
}
</script>

<style>
</style>
